<template>
  <div class="info-container">
    <toggle-upi-status v-if="getterPopupName === 'ToggleUpiStatus'"
            :upiOptions="upiOptions" @toggleStatusAction="toggleStatusAction" />

    <div class="details-panel">
      <h6>UPI Details</h6>

      <div v-for="(upi, index) in upiDetails" :key="index"
        :class="{
          row: true,
          'row-center': upi.popup
        }">
        <b>{{upi.title}}</b>
        <span>:</span>
        <p>{{upi.value}}</p>
        <button v-if="upi.popup" @click="statusConfirmation(upi.popup)" class="actions icon-btn">
          <i class="fa fa-info-circle" v-if="iciciBank">
            <md-tooltip md-direction="top">UPI of ICICI bank cannot be deactivated</md-tooltip>
          </i>
          <i v-else class="fa" :class="upiOptions.css" />
          {{upiOptions.status}}
        </button>
      </div>

      <p class="centered" v-if="!upiDetails.length">Loading...</p>
    </div>

    <button v-if="isDesktop()" class="primary-btn" @click="goBack">
      <i class="fa fa-angle-left" />Back
    </button>
  </div>
</template>

<script>
import ToggleUpiStatus from '@/components/UPIs/ToggleUpiStatus'

import ApiServices from '@/services/api/upi'
import { goBack, openPopup } from '@/utils/helpers'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'UpiDetails',
  components: { ToggleUpiStatus },
  data () {
    return {
      upiStatus: false,
      upiDetails: [],
      upiOptions: {},
      iciciBank: false
    }
  },
  beforeDestroy () {
    this.SET_SECTION_DETAILS(null)
  },
  watch: {
    getterSectionDetails (newVal) {
      this.populateData(newVal)
    }
  },
  computed: {
    ...mapGetters(['getterPopupName', 'getterSectionDetails'])
  },
  methods: {
    goBack,
    openPopup,
    ...mapMutations(['SET_SECTION_DETAILS']),
    populateData ({upi, privileges}) {
      this.upiStatus = upi.status
      const manageUpi = privileges.manage_upis
      this.iciciBank = upi.upi_id.endsWith('@icici')
      const getKeyVal = (title, value, popup) => {
        return {
          title, value, popup
        }
      }

      this.upiDetails = [
        getKeyVal('ID', upi.id),
        getKeyVal('UPI ID', upi.upi_id),
        getKeyVal('Name', upi.name),
        getKeyVal('PAN', upi.pan),
        getKeyVal('Category', upi.category),
        getKeyVal('Status', this.upiStatus, manageUpi && ['ACTIVATED', 'DEACTIVATED'].includes(this.upiStatus) ? 'ToggleUpiStatus' : null),
        getKeyVal('Address', upi.address),
        getKeyVal('Channel', upi.channel),
        getKeyVal('Created At', upi.created_at)
      ]

      if (manageUpi) {
        this.setUpiOptions()
        this.upiOptions['upi'] = upi.upi_id
      }
    },
    setUpiOptions () {
      if (this.upiStatus === 'ACTIVATED') {
        this.upiOptions['status'] = 'De-activate'
        this.upiOptions['css'] = 'fa-times'
      } else {
        this.upiOptions['status'] = 'Re-activate'
        this.upiOptions['css'] = 'fa-check'
      }
    },
    toggleStatusAction () {
      ApiServices[this.upiStatus === 'ACTIVATED' ? 'deactivate' : 'activate'](this.$route.params.id).then(response => {
        this.handleResponse(response)
      })
    },
    handleResponse (response) {
      if (response.success) {
        this.successToastMsg(response.message)
        this.openPopup(null)
        this.upiStatus = (this.upiStatus === 'ACTIVATED') ? 'DEACTIVATED' : 'ACTIVATED'
        this.upiDetails.find(e => e.title === 'Status').value = this.upiStatus
        this.setUpiOptions()
      } else {
        this.errorToastMsg(response.message)
      }
    },
    statusConfirmation (popup) {
      if (!this.iciciBank) {
        this.openPopup(popup)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/detailsPanel.scss';

  .row-center {
    align-items: center;
  }

  .desktop {
    .icon-btn {
      margin-left: 10px;
    }
  }

  .mobile, .tablet {
    .icon-btn {
      white-space: nowrap;
      padding: 5px 10px;
      margin-left: 5px;

      i {
        margin-right: 5px;
      }
    }
  }
</style>
